let endpoint = process.env.REACT_APP_BASE_URL;

// ── Site-wide branding & meta ──────────────────────────────────────
const SITE_NAME = "SiteBuilder";
const DEFAULT_LOGO = `${process.env.PUBLIC_URL}/assets/images/sitebuilder_logo.png`;
const DEFAULT_FAVICON = `${process.env.PUBLIC_URL}/assets/images/favicon-sitebuilder.png`;
const DEFAULT_COPYRIGHT = `Copyright © ${new Date().getFullYear()} ${SITE_NAME}. All rights reserved.`;

// Helper to read whitelabel from localStorage
const getWhitelabel = () => {
  try {
    const stored = localStorage.getItem("sitebuilder_user");
    if (stored) {
      const data = JSON.parse(stored);
      return data.whitelabel || null;
    }
  } catch (e) {}
  return null;
};

// siteConfig uses getters so it always reflects current whitelabel data
// Fallback chain: whitelabel → defaults
export const siteConfig = {
  get title() {
    return getWhitelabel()?.site_title || SITE_NAME;
  },
  get logo() {
    return getWhitelabel()?.logo || DEFAULT_LOGO;
  },
  get favicon() {
    return getWhitelabel()?.favicon || DEFAULT_FAVICON;
  },
  get copyright() {
    return getWhitelabel()?.footer_text || DEFAULT_COPYRIGHT;
  },
  tagline: "The all-in-one platform for building AI-powered websites in minutes.",
  supportEmail: "support@sitebuilder.com",
};

// ── API endpoints ──────────────────────────────────────────────────
export const endPoints = {
  // Legacy aliases — use getters so they always reflect current whitelabel
  get title() { return siteConfig.title; },
  get logo() { return siteConfig.logo; },
  login: endpoint + "login",
  forgot_password: endpoint + "forgotPassword",
  reset_password: endpoint + "passwordReset",

  // Settings
  insertApikeys: endpoint + "setting/insert",
  fetchKeys: endpoint + "setting/fetch",
  tutorials: endpoint + "setting/fetchTutorials",
  updateApikeys: endpoint + "setting/update",
  updateSmtpDetails: endpoint + "setting/updateDetails",
  getSettingData: endpoint + "setting/fetch",

  // Users
  getAllusers: endpoint + "users/getall",
  deleteUser: endpoint + "users/deleteUser",
  activateUser: endpoint + "users/activateUser",
  createUser: endpoint + "users/createUser",
  getUser: endpoint + "users/getUser",
  updateUser: endpoint + "users/updateUser",
  updateprofile: endpoint + "users/updateprofile",
  restrictUser: endpoint + "users/restrictUser",
  checkTos: endpoint + "users/checktos",
  acceptTos: endpoint + "users/accepttos",

  // Send mail
  sendMailData: endpoint + "mailer/sendmail",

  // Autoresponder
  fetchAllKeys: endpoint + "autoresponder/fetchAllKeys",
  validateActiveCampaign: endpoint + "autoresponder/validateActivecamp",
  insertAutoresponderkeys: endpoint + "autoresponder/inserKeys",
  disconnectResponder: endpoint + "autoresponder/disconnectResponder",
  activeCampaignLists: endpoint + "autoresponder/getActiveCampaignList",

  // Mailchimp
  validateMailchimpCampaign: endpoint + "autoresponder/validateMailchimp",
  mailchimpLists: endpoint + "autoresponder/getMailchimpLists",

  // GetResponse
  validateGetresponse: endpoint + "autoresponder/validateGetresponse",
  getResponseLists: endpoint + "autoresponder/getGetresponseLists",

  // ConvertKit
  validateConvertkit: endpoint + "autoresponder/validateConvertkit",
  convertkitTags: endpoint + "autoresponder/getConvertkitTags",

  // API Keys Management (Super Admin only)
  apiKeys: endpoint + "apikeys",

  // Projects (AI Website Builder)
  projects: endpoint + "projects",
  projectsList: endpoint + "projects/list",
  projectCreate: endpoint + "projects/create",
  projectAnalyzeUrl: endpoint + "projects/analyze-url",
  projectEnhanceDescription: endpoint + "projects/enhance-description",
  projectGenerateSitemap: endpoint + "projects/generate-sitemap",
  projectGenerateContent: endpoint + "projects/generate-content",
  projectGenerateContentStream: endpoint + "projects/generate-content-stream",
  projectRegenerateSection: endpoint + "projects/regenerate-section",
  projectAppConfig: endpoint + "projects",
  wireframes: endpoint + "wireframes",

  // Media (Images)
  mediaGallery: endpoint + "media/gallery",
  mediaUpload: endpoint + "media/upload",
  mediaDelete: endpoint + "media/delete",
  mediaUnsplash: endpoint + "media/unsplash/search",
  mediaPexels: endpoint + "media/pexels/search",
  mediaSaveExternal: endpoint + "media/save-external",
  mediaGenerateAI: endpoint + "media/generate-ai",

  // Form Submissions
  formSubmissions: endpoint + "form-submissions",

  // Whitelabel
  whitelabelGet: endpoint + "whitelabel",
  whitelabelSave: endpoint + "whitelabel",

  // Admin
  adminDashboard: endpoint + "admin/dashboard",
  adminUserStats: endpoint + "admin/user",
};
